import { Image } from 'antd-mobile'

import Default from '@/assets/images/Default@3x.png'
import { useUserAtom } from '@/store'

import { cn, customJumpHref } from '@/utils'

interface Params {
  avatar?: string
  nickname?: string
  size?: 'normal' | 'small' | 'large'
  extra?: JSX.Element
  userData: unknown
  className?: string
  avatarClassName?: string
  nickNameClassName?: string
  onClickIntro?: () => void
  jumpInfo?: boolean
}

// 人员头像组件
export function Personal({
  avatar,
  nickname = '',
  size = 'normal',
  extra,
  userData,
  className,
  avatarClassName,
  nickNameClassName,
  onClickIntro,
  jumpInfo = true,
}: Params) {
  const { user } = useUserAtom()
  const userCode = (userData as Record<string, string>)?.id
  const handleToPersonalInfoPage = () => {
    // Todo 外部导航跳转
    if (userCode && !['system', 'assistant', user.id].includes(userCode)) {
      customJumpHref(`/people/${userCode}`)
    }
  }

  return (
    <div
      className={cn(
        'comp-personal-wrap flex items-center text-base-text-color',
        size === 'normal' && 'font-toppan text-[14px]',
        size === 'small' && 'font-helvetica text-[#8e8e8f]',
        size === 'large' && '',
        userCode ? 'cursor-pointer' : '',
        className,
      )}
    >
      <Image
        src={avatar || Default}
        className={cn(
          'rounded-full',
          size === 'normal' && 'mr-[10px] h-[40px] w-[40px]',
          size === 'small' && 'mr-[5px] h-[20px] w-[20px]',
          size === 'large' && 'mr-[22px] h-[90px] w-[90px]',
          size !== 'normal' && size !== 'small' && size !== 'large' && 'h-[90px] w-[90px]',
          avatarClassName,
        )}
        fit='cover'
        alt='Avatar'
        onClick={() => {
          jumpInfo && handleToPersonalInfoPage()
        }}
        fallback={
          <img
            onClick={() => {
              jumpInfo && handleToPersonalInfoPage()
            }}
            src={Default}
            width='100%'
            height='100%'
          />
        }
        placeholder={
          <img
            onClick={() => {
              jumpInfo && handleToPersonalInfoPage()
            }}
            src={Default}
            width='100%'
            height='100%'
          />
        }
      />
      <div onClick={onClickIntro}>
        <div
          className={cn(
            'line-clamp-1 max-w-[50vw] text-ellipsis break-all font-geologica text-[24px] leading-[28px] text-base-text-color',
            size === 'small' && 'text-[#8e8e8f]',
            nickNameClassName,
          )}
        >
          {nickname}
        </div>
        {extra}
      </div>
    </div>
  )
}
